// src/app/services/session.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, map, Observable, tap} from 'rxjs';
import {SessionResponseInterface} from "../../types/session/session.response.interface";
import {SessionInterface} from "../../types/session/session.interface";

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  // private baseUrl = 'http://localhost:1337';
  private readonly SESSION_ID_KEY = 'dallepd-session-id';

  private tries = new BehaviorSubject<SessionInterface>({} as SessionInterface);
  tries$ = this.tries.asObservable();

  constructor(private http: HttpClient) {}

  getSessionId(): string | null {
    const sessionId = localStorage.getItem(this.SESSION_ID_KEY);
    console.log('Retrieved session ID from localStorage:', sessionId);
    return sessionId;
  }

  setSessionId(sessionId: string): void {
    localStorage.setItem(this.SESSION_ID_KEY, sessionId);
  }

  getSessionData(): Observable<any> {
    console.log('🔍 Making request to get-session-data');
    console.log('🌐 Current environment:', window.location.origin);
    
    return this.http.get<SessionResponseInterface>(`get-session-data`, { observe: 'response' }).pipe(
      tap(response => {
        console.log('Response headers:', response.headers.keys());
        const sessionId = response.headers.get('X-Session-ID');
        console.log('Received session ID from header:', sessionId);
        if (sessionId) {
          this.setSessionId(sessionId);
          console.log('Stored session ID in localStorage:', sessionId);
        } else {
          console.log('No X-Session-ID header found in response');
        }
      }),
      map(response => {
        this.tries.next(response.body?.session || {} as SessionInterface);
        return response.body;
      })
    );
  }
}
